// removed by extract-text-webpack-plugin
module.exports = {"modalContainer":"modalContainer-v-hd2","modalHeader":"modalHeader-22Isq","modalBody":"modalBody-38U3j","confirmButton":"confirmButton-25qhp","loader":"loader-BJojs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/util/_confirmModal.css
// module id = 1279
// module chunks = 1